import React, { useState } from 'react';
import { Box } from '@mui/material';
import {
  PrimaryTypography,
  SecondaryTypography,
} from '../../../ui/typography/typography';
import { Tabs } from '../../assessment/view/tabs/tabs';
import baseStyles from '../admin.module.css';
import { SettingsSubNav } from '../components/SettingsSubNav';
import { EntityManagement } from './EntityManagement';
import { PartnerEmployeeManagement } from './PartnerEmployeeManagement';

export const PartnerManagement = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const tabTitles = ['Entities', 'Employees'];

  const renderTabContent = () => {
    if (activeTab === 0) {
      return <EntityManagement />;
    } else if (activeTab === 1) {
      return <PartnerEmployeeManagement />;
    }
  };

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      <SettingsSubNav currentPath='/partner-management' />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Tabs
            tabTitles={tabTitles}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </Box>
        <Box sx={{ width: '100%' }}>
          {renderTabContent()}
        </Box>
      </Box>
    </Box>
  );
};
